import { isEmpty } from "lodash-es";
import { Button, PlusCircleIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useConfirm } from "melco-shared-logic";
import { useUserProductAssign } from "../../hooks/users/useUserProductAssign";

type UserProductAssignActionButtonProps = {
    productCodeToAssign: string;
    callBackFn?: () => void;
    buttonName: string;
};

export const UserProductAssignActionButton: React.FC<
    UserProductAssignActionButtonProps
> = ({ callBackFn, productCodeToAssign, buttonName }) => {
    const { t } = useTranslation();

    const assignProduct = useUserProductAssign();

    const confirmAssignProduct = useConfirm(
        async () => {

            const successfullyAssignedProduct = await assignProduct(
                productCodeToAssign
            )

            if (callBackFn && !isEmpty(successfullyAssignedProduct)) {

                callBackFn();
            }

        },
        {

            translationPrefix: "users.products.actions.assign",


        }
    );

    // if (isEmpty(selectedRowKeys)) {
    //     return null;
    // }

    return (
        <Button
            key="assignProduct"
            type="primary"
            icon={<PlusCircleIcon />}
            //disabled={isEmpty(selectedRowKeys)}
            onClick={async () => {
                await confirmAssignProduct();
            }}
            style={{ minWidth: '115px' }}
        >
            {t("users.products.actions.assign.button")}
        </Button>
    );
};
